<template>
  <div class="homepage-6">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection/>
      <ServiceSection />
      <DiscoverSection />
      <BrandingSection />
      <WorkSection />
      <ReviewSection />
      <FeatureSection />
      <ScreenshotSection />
      <PricingSection />
      <TeamSection />
      <DownloadSection />
      <NewsletterSection />
      <ContactSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/heroSix'
import ServiceSection from '../components/ServiceSection/serviceSix'
import DiscoverSection from '../components/DiscoverSection/discoverSix'
import BrandingSection from '../components/BrandingSection/branding'
import WorkSection from '../components/WorkSection/work'
import ReviewSection from '../components/ReviewSection/reviewThree'
import FeatureSection from '../components/FeatureSection/featureSix'
import ScreenshotSection from '../components/ScreenshotSection/screenshotOne'
import PricingSection from '../components/PricingSection/pricingFour'
import TeamSection from '../components/TeamSection/team'
import DownloadSection from '../components/DownloadSection/download'
import NewsletterSection from '../components/NewsletterSection/newsletter'
import ContactSection from '../components/ContactSection/contactGeneral'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'ThemeSix',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    ServiceSection,
    DiscoverSection,
    BrandingSection,
    WorkSection,
    ReviewSection,
    FeatureSection,
    ScreenshotSection,
    PricingSection,
    TeamSection,
    DownloadSection,
    NewsletterSection,
    ContactSection,
    FooterSection
  }
}
</script>

<style>

</style>